module.exports = __webpack_public_path__ + "img/photo-48.faca25f6.webp";